import React, { useState } from 'react'
import { Button, Collapse } from 'reactstrap'
import ReactMarkdown from 'react-markdown'
import ShowMoreText from "react-show-more-text";

type CardProps = {
  title: string,
  paragraph: string | undefined
}


function CommentList({ title, paragraph }: CardProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className='card-body pb-0'>
      <div className='mb-3'>
        <h3>{title}</h3>
        <div className='text-gray-800 mb-5'>
          <ShowMoreText more="Daha fazla" less="Daha az">
            <ReactMarkdown>
              {paragraph!}
            </ReactMarkdown>
          </ShowMoreText>

        </div>
        {/* <div className='d-flex align-items-center'>
          <a href='#' onClick={toggle}
            className='btn btn-sm btn-light btn-color-muted btn-active-light-success px-4 py-2 me-4'>
            <span className='svg-icon svg-icon-3'>
              <svg xmlns='http://www.w3.org/2000/svg'
                width='24' height='24'
                viewBox='0 0 24 24' fill='none'>
                <path opacity='0.3'
                  d='M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z'
                  fill='black' />
                <rect x='6' y='12' width='7' height='2'
                  rx='1' fill='black' />
                <rect x='6' y='7' width='12' height='2'
                  rx='1' fill='black' />
              </svg>
            </span>
            12
          </a>
          <a
            className='btn btn-sm btn-light btn-color-muted btn-active-light-danger px-4 py-2'>
            <span className='svg-icon svg-icon-2'>
              <svg xmlns='http://www.w3.org/2000/svg'
                width='24' height='24'
                viewBox='0 0 24 24' fill='none'>
                <path
                  d='M18.3721 4.65439C17.6415 4.23815 16.8052 4 15.9142 4C14.3444 4 12.9339 4.73924 12.003 5.89633C11.0657 4.73913 9.66 4 8.08626 4C7.19611 4 6.35789 4.23746 5.62804 4.65439C4.06148 5.54462 3 7.26056 3 9.24232C3 9.81001 3.08941 10.3491 3.25153 10.8593C4.12155 14.9013 9.69287 20 12.0034 20C14.2502 20 19.875 14.9013 20.7488 10.8593C20.9109 10.3491 21 9.81001 21 9.24232C21.0007 7.26056 19.9383 5.54462 18.3721 4.65439Z'
                  fill='black' />
              </svg>
            </span>
           150
          </a>
        </div> */}
      </div>
      <Collapse isOpen={isOpen}>
        <div className='mb-7 ps-10'>
          <div className='d-flex mb-5'>
            <div className='symbol symbol-45px me-5'>
              <img src={process.env.PUBLIC_URL + '/media/avatars/150-11.jpg'}
                alt='' />
            </div>
            <div className='d-flex flex-column flex-row-fluid'>
              <div
                className='d-flex align-items-center flex-wrap mb-1'>
                <a href='#'
                  className='text-gray-800 text-hover-primary fw-bolder me-2'>Alice
                  Danchik</a>
                <span className='text-gray-400 fw-bold fs-7'>1
                  day</span>
                <a href='#'
                  className='ms-auto text-gray-400 text-hover-primary fw-bold fs-7'>Reply</a>
              </div>
              <span className='text-gray-800 fs-7 fw-normal pt-1'>Long
                before
                you sit dow to put digital pen to paper you
                need to make
                sure you have to sit down and write.</span>
            </div>
          </div>
          <div className='d-flex'>
            <div className='symbol symbol-45px me-5'>
              <img src={process.env.PUBLIC_URL + '/media/avatars/150-8.jpg'} alt='' />
            </div>
            <div className='d-flex flex-column flex-row-fluid'>
              <div className='d-flex align-items-center flex-wrap mb-1'>
                <a href='#'
                  className='text-gray-800 text-hover-primary fw-bolder me-2'>Harris
                  Bold</a>
                <span className='text-gray-400 fw-bold fs-7'>2
                  days</span>
                <a href='#'
                  className='ms-auto text-gray-400 text-hover-primary fw-bold fs-7'>Reply</a>
              </div>
              <span className='text-gray-800 fs-7 fw-normal pt-1'>Outlines
                keep you honest. They stop you from
                indulging in
                poorly</span>
            </div>
          </div>
        </div>
        <div className='separator mb-4' />
        <form className='position-relative mb-6'>
          <textarea
            className='form-control border-0 p-0 pe-10 resize-none min-h-25px'
            data-kt-autosize='true'
            placeholder='Reply..'
          />
          <div className='position-absolute top-0 end-0 me-n5'>
            <span
              className='btn btn-icon btn-sm btn-active-color-primary pe-0 me-2'>
              {/*<!--begin::Svg Icon | path: icons/duotune/communication/com008.svg-->*/}
              <span className='svg-icon svg-icon-3 mb-3'>
                <svg xmlns='http://www.w3.org/2000/svg'
                  width='24' height='24'
                  viewBox='0 0 24 24' fill='none'>
                  <path opacity='0.3'
                    d='M4.425 20.525C2.525 18.625 2.525 15.525 4.425 13.525L14.825 3.125C16.325 1.625 18.825 1.625 20.425 3.125C20.825 3.525 20.825 4.12502 20.425 4.52502C20.025 4.92502 19.425 4.92502 19.025 4.52502C18.225 3.72502 17.025 3.72502 16.225 4.52502L5.82499 14.925C4.62499 16.125 4.62499 17.925 5.82499 19.125C7.02499 20.325 8.82501 20.325 10.025 19.125L18.425 10.725C18.825 10.325 19.425 10.325 19.825 10.725C20.225 11.125 20.225 11.725 19.825 12.125L11.425 20.525C9.525 22.425 6.425 22.425 4.425 20.525Z'
                    fill='black' />
                  <path
                    d='M9.32499 15.625C8.12499 14.425 8.12499 12.625 9.32499 11.425L14.225 6.52498C14.625 6.12498 15.225 6.12498 15.625 6.52498C16.025 6.92498 16.025 7.525 15.625 7.925L10.725 12.8249C10.325 13.2249 10.325 13.8249 10.725 14.2249C11.125 14.6249 11.725 14.6249 12.125 14.2249L19.125 7.22493C19.525 6.82493 19.725 6.425 19.725 5.925C19.725 5.325 19.525 4.825 19.125 4.425C18.725 4.025 18.725 3.42498 19.125 3.02498C19.525 2.62498 20.125 2.62498 20.525 3.02498C21.325 3.82498 21.725 4.825 21.725 5.925C21.725 6.925 21.325 7.82498 20.525 8.52498L13.525 15.525C12.325 16.725 10.525 16.725 9.32499 15.625Z'
                    fill='black' />
                </svg>
              </span>
              {/*<!--end::Svg Icon-->*/}
            </span>
            <span
              className='btn btn-icon btn-sm btn-active-color-primary ps-0'>
              <span className='svg-icon svg-icon-2 mb-3'>
                <svg xmlns='http://www.w3.org/2000/svg'
                  width='24' height='24'
                  viewBox='0 0 24 24' fill='none'>
                  <path opacity='0.3'
                    d='M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z'
                    fill='black' />
                  <path
                    d='M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z'
                    fill='black' />
                </svg>
              </span>
            </span>
          </div>
        </form>
      </Collapse>
    </div>
  )
}

export default CommentList